import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

const formSelector = formValueSelector('forgotPassword');

const getIsButtonDisabled = state => !formSelector(state, 'email');

const getIsIncorrectEmailMessageVisible = state =>
  state.auth.isIncorrectEmailMessageVisible;

const getIsSuccessMessageVisible = state =>
  state.auth.isForgotPasswordSuccessMessageVisible;

const getIsLoading = state => state.auth.isFetching;

const getForgotPassword = createSelector(
  getIsButtonDisabled,
  getIsLoading,
  getIsIncorrectEmailMessageVisible,
  getIsSuccessMessageVisible,
  (
    isButtonDisabled,
    isLoading,
    isIncorrectEmailMessageVisible,
    isSuccessMessageVisible
  ) => ({
    isButtonDisabled,
    isLoading,
    isIncorrectEmailMessageVisible,
    isSuccessMessageVisible
  })
);

export { getForgotPassword };



// WEBPACK FOOTER //
// ./src/selectors/forgotPassword.js